import { gql, useQuery } from '@apollo/client'
import { head } from 'ramda'
import React from 'react'

import { generalClient } from '../../../../../../utils/apollo/api'
import StatePresenter from '../../../../../../packages/kiti/components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useDocumentHeaderState = () => React.useContext(Context)
export const useDocumentHeader = () => useDocumentHeaderState()?.config
export const useDocumentHeaderValue = () => {
  const documentHeader = useDocumentHeader()
  if (documentHeader) {
    return documentHeader.value
  }
}

const QUERY = gql`
  query Configs($name: String) {
    configs(filter: { name: $name }) {
      id
      name
      value
      updatedAt
      insertedAt
    }
  }
`

const DocumentHeaderLoader = ({ children }) => {
  const { data, ...state } = useQuery(QUERY, {
    variables: { name: 'default_pdf_document_header' },
    client: generalClient,
    fetchPolicy: 'no-cache'
  })

  return (
    <StatePresenter {...state} empty={false}>
      <Provider value={{ ...data, config: head(data?.configs || []) }}>{children}</Provider>
    </StatePresenter>
  )
}

export default DocumentHeaderLoader
